import React, { ReactElement } from 'react';

import { TSpinnerProperties } from './spinner.types';
import { StyledChild, StyledSpinner } from './spinner.styled';

/**
 * ### Design discussions
 * - When should we show a loading spinner? Should there be a delay before showing it?
 */
export function Spinner({
    color = 'purple',
    size = 50,
}: TSpinnerProperties): ReactElement {
    return (
        <StyledSpinner size={size} data-testid="loading-spinner">
            {Array.from({ length: 12 }, (_value, key) => (
                <StyledChild
                    key={`spinner-${key}`}
                    data-testid="spinner-ball"
                    data-test-color={color}
                    spinnerColor={color}
                    number={key}
                />
            ))}
        </StyledSpinner>
    );
}
